@import "../config/_helpers";

.size-section-container {
	max-width: 800px;
}

.size-section {
	text-transform: capitalize;
	margin: 10px 0;
	flex: 0 0 100%;

	@include at-breakpoint(0, $m) {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin: 0;
		justify-content: space-between;
		flex: unset;
		gap: 0 5px;
	}

	h3 {
		@include at-breakpoint(0, $m) {
			flex: 0 0 100%;
		}
	}

	.stem-label {
		font-size: 8px;
		text-transform: uppercase;
		@include at-breakpoint(0, $m) {
			flex: 0 0 100%;
			display: none;
		}
	}

	.size-shown {
		opacity: 0.5;
		font-size: 11px;
		// text-align: right;
		// margin-left: 20px;
		display: block;
		text-transform: none;
		flex: 0 0 100%;

		&.size-shown-mob {
			margin-top: 10px;
			@include at-breakpoint($m) {
				display: none;
			}
		}
		&.size-shown-desk {
			@include at-breakpoint(0, $m) {
				display: none;
			}

			opacity: 0;
			transition: 0.4s opacity ease-in-out;
			&.active {
				opacity: 1;
			}
		}
	}

	.popular-choice {
		background: black;
		color: white;
		padding: 2px;
		margin-left: auto;
		display: block;
		font-size: smaller;
		border-radius: 5px;
		@include at-breakpoint(0, $l) {
			margin-left: 0;
		}
	}

	.size-choice {
		padding: 5px 0;
		--gap: 5px;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		padding: 10px;
		transition: 0.4s background ease-in-out;
		max-width: 33.33%;

		&:last-of-type {
			margin-right: auto;
		}

		@include at-breakpoint(0, $m) {
			flex: 1;
			// background: var(--tertiary-color-light-5);
			text-align: center;
			border-radius: 5px;
			&.active {
				background: var(--tertiary-color-light-3);
			}
			.col-fit {
				flex: 0 0 100%;
				.stem-count {
					margin: 0 auto;
				}
			}
		}

		.stem-count {
			background: var(--tertiary-color-light-6);
			color: var(--tertiary-color);

			aspect-ratio: 1/1;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			width: 100%;
			margin: 10px;
			width: 30px;
			position: relative;

			&:after {
				content: "";
				width: 30px;
				opacity: 0;
				border: 2px solid var(--tertiary-color);
				position: absolute;
				aspect-ratio: 1/1;
				border-radius: 50%;
				transition: 0.4s opacity ease-in-out;
			}
		}

		&.active {
			background: var(--accent-color);
		}
	}
}
